import { useCallback, useState } from 'react';

import { ICommentMessage } from '@entities/message/model/types';

export const useDeleteMessage = () => {
    const [isOpenDeleteConfirmPopup, setIsOpenDeleteConfirmPopup] = useState(false);
    const [messageToDeleteId, setMessageToDeleteId] = useState<ICommentMessage['id']>(null);

    const openDeletePopup = useCallback((messageId: ICommentMessage['id']) => {
        setIsOpenDeleteConfirmPopup(true);
        setMessageToDeleteId(messageId);
    }, []);

    const closeDeletePopup = useCallback(() => {
        setIsOpenDeleteConfirmPopup(false);
        setMessageToDeleteId(null);
    }, []);

    return {
        isOpenDeleteConfirmPopup,
        messageToDeleteId,
        openDeletePopup,
        closeDeletePopup,
    };
};
